import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import TextField from 'material-ui/TextField';
import RaisedButton from 'material-ui/RaisedButton';

import GazetterItem from './GazetterItem';
import Autocomplete from 'react-autocomplete';

import { AutoSizer } from 'react-virtualized/dist/es/AutoSizer';
import { List } from 'react-virtualized/dist/es/List';
import * as cx from 'classnames';

const styles = {
    textField: {
        hintStyle: {
            fontSize: '12px',
        },
        style: {
            fontSize: '12px',
        },
    },
    button: {
        labelStyle: { fontSize: '10px' },
        style: { height: '25px', margin: '0' },
        buttonStyle: { height: '25px', lineHeight: '25px' },
    },
    tableButton: {
        labelStyle: { fontSize: '10px' },
        style: { height: '25px' },
        buttonStyle: { height: '25px', lineHeight: '25px' },
    },
    autocomplete: {
        menuStyle: {
            borderRadius: '3px',
            boxShadow: '0 2px 12px rgba(0, 0, 0, 0.1)',
            background: 'rgba(255, 255, 255, 0.9)',
            padding: '2px 0',
            fontSize: '16px',
            position: 'absolute',
            overflow: 'auto',
            left: 0,
            bottom: 0,
            top: '25px',
            minHeight: '200px',
            zIndex: 1111,

        },
        wrapperStyle: {
            width: '100%',
            position: 'relative',
        },

    },
};

class GazetterList extends React.PureComponent {
    constructor(props) {
        super(props);

        this.renderRow = this.renderRow.bind(this);
        this.changeRow = this.changeRow.bind(this);
    }

    changeRow(fields, gazetter) {
        const cloneGazetter = _.clone(gazetter);

        fields.forEach((item) => {
            _.set(cloneGazetter, item.field, item.value);
        });

        this.props.changeGazetter({
            ...cloneGazetter,
            value: cloneGazetter.value,
            GazetterType: cloneGazetter.GazetterType,
            GazetterName: cloneGazetter.GazetterName,
        });
    }

    renderRow({ index, key, style }) {
        const {
            gazetters, listGazetters, removeGazetter, clearGazetter, 
        } = this.props;
        const gazetter = gazetters[index];
        const featuresValue = JSON.stringify(gazetter.features || {}, null, 2);

        function renderMenu(items, value, style) {
            return <div style={{ ...style, ...this.menuStyle }} children={items} />;
        }

        return (
            <div
                style={{ ...style }}
                key={key}
                className={`gazetter-row ${gazetter.status}`}
            >
                <div className="column">
                    <Autocomplete
                        menuStyle={styles.autocomplete.menuStyle}
                        wrapperStyle={styles.autocomplete.wrapperStyle}
                        getItemValue={item => item.fileName}
                        items={listGazetters.filteredList}
                        renderMenu={renderMenu}
                        renderItem={(item, isHighlighted, ...props) => (
                            <div key={index} style={{ height: '25px', cursor: 'pointer', background: isHighlighted ? 'lightgray' : 'white' }}>
                                {item.fileName}
                            </div>
                        )}
                        shouldItemRender={(item, value) => item.fileName.toLowerCase().indexOf(value.toLowerCase()) > -1}
                        value={gazetter.GazetterName}
                        onChange={(e) => {
                            this.changeRow([{ field: 'GazetterName', value: e.target.value }], gazetter);
                        }}
                        onSelect={(name, item) => {
                            this.changeRow([{ field: 'GazetterName', value: name }, { field: 'GazetterType', value: item.$target }], gazetter);
                        }}
                    />
                </div>
                <div className="column group">
                    <select
                        type='text'
                        onChange={(e) => {
                            this.changeRow([{ field: 'GazetterType', value: e.target.value }], gazetter);
                        }}
                        value={gazetter.GazetterType}
                    >
                        <option value='common'>common</option>
                        <option value='cargo'>cargo</option>
                        <option value='vessel'>vessel</option>
                    </select>
                </div>
                <div className="column">
                    <input
                        type='text'
                        value={gazetter.value}
                        onChange={(e) => {
                            this.changeRow([{ field: 'value', value: e.target.value }], gazetter);
                        }}
                    />
                </div>
                <div className="column features" title={featuresValue}>
                    <span className="features-value">{featuresValue}</span>
                </div>
                <div className="column management">
                    <RaisedButton
                        labelStyle={styles.button.labelStyle}
                        style={styles.button.style}
                        buttonStyle={styles.button.buttonStyle}
                        label='DELETE'
                        onClick={() => { removeGazetter(gazetter); }}
                        secondary
                    />
                    {
                        gazetter.status && gazetter.status !== 'new' ?
                            <RaisedButton
                                labelStyle={styles.button.labelStyle}
                                style={styles.button.style}
                                buttonStyle={styles.button.buttonStyle}
                                label='CLEAR'
                                onClick={() => { clearGazetter(gazetter); }}
                                primary
                            />
                            :
                            null
                    }
                </div>
            </div>
        );
    }

    render() {
        const {
            gazetters, searchText, addNewGazetter, filterGazetters, saveGazetters, isError, 
        } = this.props;

        let renderComponent = (<div className='gazetters-list-b container-fluid'>
            <div className='row middle-xs'>
                <div className='col-xs-3'>
                    <TextField
                        hintText='Search'
                        hintStyle={styles.textField.hintStyle}
                        style={styles.textField.style}
                        onChange={(e, value) => {
                            filterGazetters(value);
                        }}
                        value={searchText}
                    />
                </div>

                <div className='col-xs-9'>
                    <RaisedButton
                        label='Add word'
                        labelStyle={styles.button.labelStyle}
                        style={styles.button.style}
                        buttonStyle={styles.button.buttonStyle}
                        onClick={() => {
                            addNewGazetter({});
                        }}
                        primary
                    />
                    <RaisedButton
                        label='Save gazetters'
                        labelStyle={styles.button.labelStyle}
                        style={styles.button.style}
                        buttonStyle={styles.button.buttonStyle}
                        onClick={saveGazetters}
                        primary
                    />
                    <span style={{ fontSize: '13px' }}>
                        Total found unique words: {gazetters.length}
                    </span>
                </div>
            </div>

            <div className='gazetters-table'>
                <div className='gazetter-row'>
                    <div className='header-column'>Gazetter</div>
                    <div className='header-column group'>Group</div>
                    <div className='header-column'>Word</div>
                    <div className='header-column features'>Features</div>
                    <div className='header-column management'>&nbsp;</div>
                </div>

                <div className="gazetter-table-body">
                    <AutoSizer>
                        {
                            ({ width, height }) => (<List
                                ref={(list) => { this.list = list; }}
                                rowRenderer={this.renderRow}
                                height={height}
                                width={width}
                                rowHeight={25}
                                rowCount={gazetters.length}
                                gazetters={gazetters}
                            />)
                        }
                    </AutoSizer>
                </div>


                {/*{*/}
                {/*gazetters.map((gazetter, i) => {*/}
                {/*return <GazetterItem*/}
                {/*gazetters={gazetters}*/}
                {/*gazetter={gazetter}*/}
                {/*listGazetters={listGazetters}*/}
                {/*key={gazetter.id}*/}
                {/*changeGazetter={this.changeGazetter}*/}
                {/*removeGazetter={removeGazetter}*/}
                {/*clearGazetter={clearGazetter}*/}
                {/*/>;*/}
                {/*})*/}
                {/*}*/}
            </div>
        </div>);

        let renderError = 'Something wrong with request';
        
        if (isError) {
            renderComponent = null;
        } else {
            renderError = null;
        }
        
        return (
            <div>
                {renderComponent}
                {renderError}
            </div>
        );
    }
}

export default connect(
    (state, ownProps) => ({
        ...ownProps,
        isError: state.gazetters.isError,
        listGazetters: state.listGazetters,
    }),
    dispatch => bindActionCreators({}, dispatch),
)(GazetterList);



// WEBPACK FOOTER //
// ./app/components/Letters/Single/Gazetter/List/Gazetter.jsx